
































































import jQuery from 'jquery';
import JQuery from 'jquery';
import 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';
import { defineComponent, onMounted, onUnmounted, PropType, ref, watch } from '@vue/composition-api';
import { DataFormat } from 'select2';
import { S2Selection } from '@/types/s2selection';

export default defineComponent({
  name: 'Select2',
  props: {
    tabindex: {
      type: Number,
      default: 0
    },
    id: String,
    error: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Vælg'
    },
    icon: {
      type: Array,
      required: false
    },
    title: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    allowSearch: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    loadingPlaceholder: {
      type: String,
      default: 'Henter data ...'
    },
    isTagged: {
      type: Boolean,
      default: false
    },
    renderer: {
      default: null
    },
    selectedRenderer: {
      default: null
    },
    adapter: null,
    data: {
      type: Array as PropType<S2Selection<unknown>[]>,
      default: []
    },
    value: null,
    templateResult: {
      type: Function,
      default: (data: { text: any }) => data.text
    }
  },
  setup(props, context) {
    // Component properties

    const isOpen = ref(false);
    const select2 = ref(null as HTMLSelectElement | null);

    function onChange() {
      if (select2.value) {
        const jSelect = jQuery(select2.value);

        if (props.multiple) {
          const selections = jSelect.select2('data').map(element => {
            return props.isTagged
              ? new S2Selection(element.text, element.text, element.text, props.templateResult)
              : props.data[element.element.index];
          });
          context.emit('input', selections);
        } else {
          const selections = jSelect.select2('data').map(element => {
            return props.data[element.element.index];
          });
          context.emit('input', selections[0]);
        }
      }
    }

    function setValue(
      element: JQuery<HTMLSelectElement>,
      value: S2Selection<unknown>[] | S2Selection<unknown> | null
    ) {
      function asArray(value: S2Selection<unknown>[] | S2Selection<unknown> | null): value is S2Selection<unknown>[] {
        if ((value as S2Selection<unknown>[])?.length > 0) {
          return true;
        } else {
          return false;
        }
      }

      function asSingle(value: S2Selection<unknown>[] | S2Selection<unknown> | null): value is S2Selection<unknown> {
        if ((value as S2Selection<unknown>)?.id != null) {
          return true;
        } else {
          return false;
        }
      }

      if (props.multiple && asArray(value)) {
        element.val(value.map(element => element.id)).trigger('change');
      } else if (asSingle(value)) {
        element.val(value.id).trigger('change');
      } else {
        element.val('').trigger('change');
      }
    }

    function setup(element: JQuery<HTMLSelectElement>) {
      element.empty();
      element.off('select2:select select2:unselect');
      element.off('select2:close');
      element.off('select2:open');

      const settings: any = {
        ...useSettings(
          props.isLoading,
          props.placeholder,
          props.loadingPlaceholder,
          props.isTagged,
          props.allowClear,
          props.multiple,
          props.allowSearch,
          props.templateResult,
          props.data
        ),
        ...useRenderSettings(props.renderer, props.selectedRenderer),
        ...useAdapter(props.adapter)
      };

      element.select2(settings);
      setValue(element, props.value);

      element.on('select2:select select2:unselect', onChange);
      element.on('select2:close', onClose);
      element.on('select2:open', onOpen);
    }

    function onClose() {
      isOpen.value = false;
      context.emit('blur');
    }

    function onOpen() {
      isOpen.value = true;
    }

    watch(
      () => props.value,
      newValue => {
        if (select2.value) {
          setValue(jQuery(select2.value), newValue);
        }
      }
    );

    watch([() => props.isLoading, () => props.data], () => {
      if (select2.value) {
        setup(jQuery(select2.value));
      }
    });

    onMounted(() => {
      if (select2.value) {
        setup(jQuery(select2.value));
      }
    });

    onUnmounted(() => {
      if (select2.value) {
        jQuery(select2.value).select2('destroy');
      }
    });

    return { select2, isOpen };
  }
});

function useRenderSettings(render: any, selectionRender: any): any {
  return render
    ? { templateResult: render, templateSelection: render }
    : selectionRender
      ? { templateSelection: selectionRender }
      : {};
}

function useAdapter(adapter: unknown | null): any {
  return adapter ? { ajax: {}, dataAdapter: adapter } : {};
}

function useSettings(
  isLoading: boolean,
  placeholder: string,
  loadingPlaceholder: string,
  isTagged: boolean,
  allowClear: boolean,
  multiple: boolean,
  allowSearch: boolean,
  templateResult: any,
  data: DataFormat[]
): any {
  return {
    theme: 'bootstrap',
    width: '100%',
    data: data,
    placeholder: isLoading ? loadingPlaceholder : placeholder,
    allowClear: allowClear,
    multiple: multiple,
    tags: isTagged,
    templateResult: templateResult,
    minimumResultsForSearch: allowSearch ? 1 : Infinity,
    tokenSeparators: isTagged ? [',', ' '] : [],
    language: {
      noResults: function () {
        if (isTagged) {
          return '';
        } else {
          return 'Ingen resultater fundet';
        }
      }
    },
    escapeMarkup: function (value: any) {
      return value;
    }
  };
}
